import SocialVariantDesigner from '@admin/components/social_variant_designer'
import Translate from '@apps/maha/admin/components/translate'
import ProfileToken from '@admin/tokens/profile'
import Panel from '@admin/components/panel'
import React from 'react'

const getSocialVariantDesigner = (social_campaign) => ({
  entity: 'campaigns_social_campaign_variants',
  editable: ['draft','scheduled'].includes(social_campaign.status),
  format: ProfileToken,
  social_campaign,
  save_all_endpoint: `/api/admin/campaigns/social/${social_campaign.id}/variants/saveall`
})

const mapPropsToPanel = (props, context) => ({
  title: 't(Design)',
  component: <SocialVariantDesigner { ...getSocialVariantDesigner(props.social_campaign) } />,
  ..._.includes(['draft','scheduled'], props.social_campaign.status) ? {
    tasks: {
      items: [
        {
          label: 't(Translate Campaign)',
          svg: 'flag',
          modal: <Translate entity_type='campaigns_social_campaigns' entity_id={ props.social_campaign.id } mjson_type='social' publish={ false } />
        }
      ]
    }
  } : {}
})

export default Panel(null, mapPropsToPanel)
